<template>
  <div
    class="multipleChoiceShare_fixedBtn"
    :class="[
      model,
      state,
      isFixedBtnIconOpen ? 'open' : '',
      isHide ? 'hide' : '',
      changeOptions ? 'changeOptions' : '',
    ]"
    :style="{
      top: model === 'circular' ? fixedBtn_absTopArr[1] : fixedBtn_absTopArr[0],
    }"
  >
    <span
      class="mainBtnArea"
      @click="clickFixedBtn(isFixedBtnIconOpen)"
      :class="rectBtnShowBorder ? 'rectBtnShowBorder' : ''"
    >
      <span v-text="model === 'rect' ? `${modeType.btnName}` : ''"></span>
    </span>
    <span v-if="changeOptions" class="changeBtn_fixedBtn" @click="changeType()">
      <svg
        t="1695651706714"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="22643"
      >
        <path
          d="M714.4 448.21h162.74a10.13 10.13 0 0 0 8.43-15.74l-114.39-172a10.12 10.12 0 0 0-8.51-4.51l-36.51 0.28a22.05 22.05 0 0 0-21.88 22.05v60.26a18.65 18.65 0 0 1-18.65 18.65h-548a10.13 10.13 0 0 0-10.13 10.13v70.71a10.14 10.14 0 0 0 10.13 10.13zM885.75 576h-739a9.91 9.91 0 0 0-9.83 8.54 10.36 10.36 0 0 0 1.6 7.88l110.94 165.69a22.1 22.1 0 0 0 18.43 9.81l29.33-0.07a22.11 22.11 0 0 0 22.07-22.12v-60.65A18.07 18.07 0 0 1 337.36 667h548.39a9.93 9.93 0 0 0 9.93-9.93V586a9.94 9.94 0 0 0-9.93-10z"
          p-id="22644"
        ></path>
      </svg>
    </span>
    <span class="optsList" v-show="isChangeOptsListOpen && changeOptions">
      <span
        class="optsItem"
        v-for="opt in changeOptions"
        :key="opt.type"
        v-text="opt.shortName"
        :class="opt.type === modeType.type ? 'act' : ''"
        @click="clickChangeOptsItem(opt)"
      ></span>
    </span>
    <span
      class="smallIcon"
      :class="smallBtn.type"
      v-for="smallBtn in smallBtnArr"
      :key="smallBtn.type"
      @click="clickSmallBtn(smallBtn)"
    >
      <template v-if="smallBtn.type === 'share'">
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="60%"
          height="60%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </template>
      <template v-else-if="smallBtn.type === 'check'">
        <span v-text="smallBtn.val"></span>
      </template>
      <template v-else-if="smallBtn.type === 'cancel'">
        <svg
          t="1693663749023"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="18513"
          width="40%"
          height="40%"
        >
          <path
            d="M1003.401416 20.47758a69.809932 69.809932 0 0 1 4.840155 93.405688l-4.793615 5.305555L610.604201 511.939498l392.797215 392.797215a69.809932 69.809932 0 0 1-93.452228 103.504858l-5.305555-4.793615L511.939498 610.604201l-392.797215 392.797215a69.809932 69.809932 0 0 1-93.405688 4.793615L20.47758 1003.401416a69.809932 69.809932 0 0 1-4.793615-93.452228l4.793615-5.305555L413.274795 511.939498 20.43104 119.142283A69.809932 69.809932 0 0 1 113.883268 15.683965L119.142283 20.47758 511.939498 413.274795l392.797215-392.797215a69.809932 69.809932 0 0 1 98.664703 0z"
            p-id="18514"
          ></path>
        </svg>
      </template>
    </span>

    <!-- <span class="smallIcon check" v-text="19"></span>
    <span class="smallIcon cancel">
      <svg
        t="1693663749023"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="18513"
        width="40%"
        height="40%"
      >
        <path
          d="M1003.401416 20.47758a69.809932 69.809932 0 0 1 4.840155 93.405688l-4.793615 5.305555L610.604201 511.939498l392.797215 392.797215a69.809932 69.809932 0 0 1-93.452228 103.504858l-5.305555-4.793615L511.939498 610.604201l-392.797215 392.797215a69.809932 69.809932 0 0 1-93.405688 4.793615L20.47758 1003.401416a69.809932 69.809932 0 0 1-4.793615-93.452228l4.793615-5.305555L413.274795 511.939498 20.43104 119.142283A69.809932 69.809932 0 0 1 113.883268 15.683965L119.142283 20.47758 511.939498 413.274795l392.797215-392.797215a69.809932 69.809932 0 0 1 98.664703 0z"
          p-id="18514"
        ></path>
      </svg>
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'multipleChoiceShare_fixedBtn',
  props: {
    model: {
      type: String,
      default: 'rect', //['rect', 'circular']
    },
    state: {
      type: String,
      default: 'default', //[['choose','default']
    },
    smallBtnArr: {
      type: Array,
      default: () => {
        return [
          {
            type: 'share',
            name: '分享',
          },
          {
            type: 'check',
            name: '查看',
            val: 99,
          },
          {
            type: 'cancel',
            name: '取消',
          },
        ]
      },
    },
    modeType: {
      type: Object,
      default: () => ({
        btnName: '未定义',
        localStorageName: '',
        unit: '',
      }),
    },
    fixedBtn_absTopArr: {
      type: Array,
      default: () => {
        return ['18vw', '24.5vw'] //'rect', 'circular'
      },
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    changeOptions: {
      //需要切换多选的时候，传这个参数，不需要则不传救不回展示
      type: Array,
      default: null,
    },
    rectBtnShowBorder: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    state: {
      handler(newVal, oldVal) {
        if (newVal === 'default') {
          this.isFixedBtnIconOpen = false
        }
      },
    },
  },
  data() {
    return {
      //   model: 'circular', //['rect', 'circular']
      //   state: 'default', //['choose','default']
      isFixedBtnIconOpen: false,
      isChangeOptsListOpen: false,
    }
  },
  computed: {
    isHide() {
      console.debug('this.isShow:', this.isShow)
      // if (!this.isShow && this.model === 'rect') {
      //   return true
      // } else {
      //   return false
      // }
      if (!this.isShow) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    // changeState() {
    //   if (this.model === 'rect') {
    //     this.model = 'circular'
    //   } else {
    //     this.model = 'rect'
    //   }
    // },
    changeType() {
      if (this.model === 'rect') {
        this.$emit('changeTypeEvent', { type: 'rect', modeType: this.modeType })
      } else {
        this.isChangeOptsListOpen = !this.isChangeOptsListOpen
      }
    },
    clickChangeOptsItem(clickItem) {
      console.debug('this.modeType:', clickItem, this.changeOptions)
      this.$emit('changeTypeEvent', {
        type: 'circular',
        modeType: clickItem,
      })
      this.isChangeOptsListOpen = false
    },
    clickFixedBtn(flag) {
      console.debug('clickFixedBtn:', flag)
      if (flag && this.isChangeOptsListOpen) {
        this.isChangeOptsListOpen = false
      }
      if (this.state === 'default') {
        this.isFixedBtnIconOpen = !flag
        this.$emit('clickFixedBtnEvent', 'choose')
      } else if (this.state === 'choose') {
        this.isFixedBtnIconOpen = !flag
      }

      if (this.model === 'rect') {
        this.$emit('changeModelEvent', 'circular')
      }
      console.debug('clickFixedBtn:', this.isFixedBtnIconOpen, this.state)
    },
    clickSmallBtn(item) {
      let dialogText = ''
      let addNum = 0
      if (
        this.smallBtnArr &&
        this.smallBtnArr[1] &&
        this.smallBtnArr[1].val > 0
      ) {
        addNum = this.smallBtnArr[1].val
      }
      if (item.type === 'cancel') {
        if (addNum > 0) {
          dialogText = `是否取消【${this.modeType.btnName}】主题，确定后将清除之前选择的赛程`
        } else {
          dialogText = `是否取消【${this.modeType.btnName}】主题`
        }
        this.$emit('clickSmallBtnEvent', {
          isDialogFlag: true,
          dialogType: item.type,
          dialogText,
        })
      } else if (item.type === 'check') {
        dialogText = `${this.modeType.btnName}`
        this.$emit('clickSmallBtnEvent', {
          isDialogFlag: true,
          dialogType: item.type,
          dialogText,
          otherTextArr: [item.val],
        })
      } else if (item.type === 'share') {
        let type = ''
        if (addNum > 0) {
          type = item.type
          // dialogText = `请确认主题【${this.modeType.btnName}】的分享配置，目前已添加：${addNum}${this.modeType.unit}`
          dialogText = `请确认主题【${this.modeType.btnName}】的分享配置，目前已添加：${addNum}`
        } else {
          dialogText = `您还未选择要分享的数据，请选择后再分享主题`
          type = 'tip' //展示提示框
        }
        this.$emit('clickSmallBtnEvent', {
          isDialogFlag: true,
          dialogType: type,
          dialogText,
        })
      }
      this.isChangeOptsListOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.multipleChoiceShare_fixedBtn {
  position: fixed;
  z-index: 1000;
  transition: 0.2s top 0.2s linear;
  /* transition: all 0.3s linear; */
  &.hide {
    display: none;
  }
  &.rect {
    right: 9.722vw;
    /* top: 18vw; */
    width: 11.1vw;
    height: 3.47vw;
    &.changeOptions {
      .mainBtnArea {
        span {
          padding-right: 1.388vw;
        }
      }
    }
    .mainBtnArea {
      background-color: var(--mixtmt_subColor1_1);
      border: 1px solid var(--mixtmt_subColor1_1);
      border-radius: 0.347vw;
      color: var(--mixtmt_whiteColor);
      &.rectBtnShowBorder {
        border: 1px solid var(--mixtmt_subColor_programBorder);
      }
      & > span {
        opacity: 1;
        color: var(--mixtmt_whiteColor);
        transition: all 0.3s linear;
      }
    }
    .changeBtn_fixedBtn {
      top: 50%;
      right: 0.347vw;
      width: 2.36vw;
      height: 2.36vw;
      transform: translateY(-50%);
      z-index: 10;
      svg {
        width: 60%;
        height: 60%;
        fill: var(--mixtmt_whiteColor);
      }
      &:hover {
        background-color: var(--mixtmt_subColor1_1);
        border-radius: 50%;
        border: 1px solid var(--mixtmt_whiteColor);
        svg {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
  }
  &.circular {
    right: 3.125vw;
    /* top: 24.5vw; */
    width: 3.47vw;
    height: 3.47vw;
    -webkit-animation: bouncedelay 0.2s ease-in;
    animation: bouncedelay 0.2s ease-in;
    .mainBtnArea {
      background-color: var(--mixtmt_whiteColor);
      border-radius: 50%;
      border: 1px solid var(--mixtmt_greyColor7);
      &::before,
      &::after,
      & > span {
        opacity: 1;
        transition: all 0.3s linear;
      }
    }
    .changeBtn_fixedBtn {
      top: 50%;
      right: 50%;
      width: 0;
      height: 0;
      z-index: 3;
      background-color: var(--mixtmt_whiteColor);
      border-radius: 50%;
      border: 1px solid var(--mixtmt_greyColor7);
      svg {
        width: 70%;
        height: 70%;
        fill: var(--mixtmt_greyColor6);
      }
      &:hover {
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
        svg {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
    &.choose {
      .mainBtnArea {
        &::before {
          top: calc(50% - 0.55vw);
          transform: translate(-50%, -50%);
        }
        &::after {
          top: calc(50% + 0.55vw);
          transform: translate(-50%, -50%) rotate(0deg);
        }
        & > span {
          opacity: 1;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 2;
          width: 40%;
          height: 0.138vw;
          transform: translate(-50%, -50%);
          background-color: var(--mixtmt_greyColor6);
        }
      }
      &.open {
        .changeBtn_fixedBtn {
          top: 100%;
          right: -50%;
          width: 2.36vw;
          height: 2.36vw;
        }
        .smallIcon {
          width: 2.36vw;
          height: 2.36vw;
          color: var(--mixtmt_greyColor6);
          &.share {
            top: -80%;
            left: 50%;
            svg {
              fill: var(--mixtmt_greyColor6);
            }
          }
          &.check {
            top: -30%;
            left: -40%;
            font-size: 0.974vw;
          }
          &.cancel {
            top: -30%;
            left: 140%;
            svg {
              fill: var(--mixtmt_greyColor6);
            }
          }
        }
      }
    }
  }

  .changeBtn_fixedBtn {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    transition: all 0.3s linear;
  }
  .optsList {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 130%;
    right: -0.6vw;
    z-index: 2;
    width: calc(100% + 1vw);
    /* height: 5.56vw; */
    height: auto;
    background-color: var(--mixtmt_whiteColor);
    border: 1px solid var(--mixtmt_greyColor7);
    /* padding: 0 0.347vw; */
    border-radius: 0.278vw;
    .optsItem {
      width: 100%;
      font-size: 0.833vw;
      line-height: 2.083vw;
      text-align: center;
      color: var(--mixtmt_greyColor6);
      border-bottom: 1px solid var(--mixtmt_greyColor7);
      &.act,
      &:hover {
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_mainColor);
      }
      &:first-child {
        border-radius: 0.278vw 00.278vw 0 0;
      }
      &:last-child {
        border-bottom: 0;
        border-radius: 0 0 0.278vw 00.278vw;
      }
    }
  }
  @-webkit-keyframes bouncedelay {
    0% {
      right: 9.722vw;
      border-radius: 0;
    }
    100% {
      right: 3.125vw;
      border-radius: 50%;
    }
  }

  @keyframes bouncedelay {
    0% {
      right: 9.722vw;
      border-radius: 0;
    }
    100% {
      right: 3.125vw;
      border-radius: 50%;
    }
  }
  .mainBtnArea {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s linear;
    &::before,
    &::after {
      opacity: 0;
      display: block;
      content: '\20';
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: 40%;
      height: 0.138vw;
      background-color: var(--mixtmt_greyColor6);
      border-radius: 0.104vw;
    }
    &::before {
      transform: translate(-50%, -50%);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(90deg);
    }
    & > span {
      opacity: 0;
      border-radius: 0.104vw;
    }
  }
  .smallIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 0;
    height: 0;
    background-color: var(--mixtmt_whiteColor);
    border-radius: 50%;
    border: 1px solid var(--mixtmt_greyColor7);
    transform: translate(-50%, -50%);
    transition: all 0.3s linear;
  }
}

.mixtmt_pc .multipleChoiceShare_fixedBtn {
  &:hover {
    cursor: pointer;
    &.rect {
      .mainBtnArea {
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
        &.rectBtnShowBorder {
          border: 1px solid var(--mixtmt_mainColor_programBorder);
        }
      }
    }
    &.circular {
      .mainBtnArea {
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
        &::before,
        &::after,
        & > span {
          background-color: var(--mixtmt_whiteColor);
          transition: all 0.3s linear;
        }
      }
      &.choose {
        .smallIcon {
          &:hover {
            background-color: var(--mixtmt_mainColor);
            border: 1px solid var(--mixtmt_mainColor);
            color: var(--mixtmt_whiteColor);
          }
          &.share,
          &.cancel {
            &:hover {
              svg {
                fill: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
    }
  }
}
</style>
